<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="help" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Quick Start & Tutorials</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    Not Implemented Yet.
<!-- This section works!!!  Put this back in when I have tutorial. 
    @for (tutorial of tutorials; track $index) {
  <ion-card>
        <ion-card-header>
            <ion-card-title [innerHTML]="tutorial.title"></ion-card-title>
            <ion-card-subtitle>Video #{{ tutorial.sequenceNumber }}</ion-card-subtitle>
            <ion-card-subtitle>{{ post.date_gmt | date }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
            <iframe width="100%" height="315" [src]="tutorial.trustedUrl" frameborder="0" allowfullscreen></iframe>
            <div [innerHTML]="tutorial.description"></div>
        </ion-card-content>
    </ion-card>
} 
-->

    <!-- <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMore($event)">
        <ion-infinite-scroll-content loadingText="Loading more posts...">
        </ion-infinite-scroll-content>
    </ion-infinite-scroll> -->
</ion-content>

<!-- 
This is what the iframe should look like:
<iframe width="560" height="315" src="https://www.youtube.com/embed/fuhQru2o-RU" 
    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; 
    encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
</iframe>
-->


